import React from 'react';
import { colors } from '../../styles/colors';

const periods = ['Q1', 'Q2', 'Q3', 'Q4', 'ANNUEL'];
const periodLabels = ['T1', 'T2', 'T3', 'T4', 'ANNUEL'];
const zero = { Q1: 0, Q2: 0, Q3: 0, Q4: 0, ANNUEL: 0 };

function Row({ label, data, formatValue, bg, textColor, bold, resteMode }) {
  return (
    <tr style={{ backgroundColor: bg || 'white' }}>
      <td style={{
        padding: '0.6rem 1rem',
        fontSize: '0.85rem',
        fontWeight: bold ? '600' : '400',
        color: textColor || colors.primary.gray,
        whiteSpace: 'nowrap'
      }}>
        {label}
      </td>
      {periods.map(p => {
        const val = data?.[p] || 0;
        let color = textColor || colors.primary.gray;
        if (resteMode) {
          color = val > 0 ? colors.status.error : colors.status.success;
        }
        return (
          <td key={p} style={{
            padding: '0.6rem 1rem',
            textAlign: 'right',
            fontSize: '0.85rem',
            fontWeight: bold ? '600' : '400',
            color,
            whiteSpace: 'nowrap'
          }}>
            {formatValue(val)}
          </td>
        );
      })}
    </tr>
  );
}

/**
 * Tableau P&L - Refacturation HT
 * Un tableau par consultant avec design epure
 */
function PLRefacturationTable({ calculations, formatMontant }) {
  const quotePart = calculations.quotePart;
  const shared = quotePart?.shared || zero;

  const getSpecificCharges = (name) => {
    const total = quotePart?.byConsultant?.[name];
    if (!total) return zero;
    return {
      Q1: total.Q1 - shared.Q1,
      Q2: total.Q2 - shared.Q2,
      Q3: total.Q3 - shared.Q3,
      Q4: total.Q4 - shared.Q4,
      ANNUEL: total.ANNUEL - shared.ANNUEL
    };
  };

  const hasAnyValue = (data) => {
    if (!data) return false;
    return data.Q1 !== 0 || data.Q2 !== 0 || data.Q3 !== 0 || data.Q4 !== 0;
  };

  const cardStyle = {
    backgroundColor: 'white',
    border: `1.5px solid ${colors.primary.teal}`,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    width: '1000px',
    maxWidth: '95vw'
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginBottom: '2rem' }}>
      {calculations.consultants.map(consultant => {
        const ca = calculations.refacturationByConsultant?.[consultant] || calculations.caByConsultant?.[consultant] || zero;
        const specificCharges = getSpecificCharges(consultant);
        const showSpecific = hasAnyValue(specificCharges);
        const caNet = calculations.caNet?.[consultant] || zero;
        const factures = calculations.factures?.[consultant] || zero;
        const reste = calculations.reste?.[consultant] || zero;

        return (
          <div key={consultant} style={cardStyle}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: colors.primary.teal }}>
                  <th style={{
                    padding: '0.7rem 1rem',
                    textAlign: 'left',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '0.875rem'
                  }}>
                    {consultant}
                  </th>
                  {periodLabels.map(label => (
                    <th key={label} style={{
                      padding: '0.7rem 1rem',
                      textAlign: 'right',
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '0.875rem'
                    }}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <Row
                  label="Chiffre d'affaires"
                  data={ca}
                  formatValue={formatMontant}
                  bg={`${colors.primary.teal}20`}
                  textColor={colors.primary.teal}
                  bold
                />
                <Row
                  label="Quote-part commune"
                  data={shared}
                  formatValue={formatMontant}
                  bg={`${colors.primary.gray}15`}
                  textColor={colors.text.secondary}
                />
                {showSpecific && (
                  <Row
                    label="Charges specifiques"
                    data={specificCharges}
                    formatValue={formatMontant}
                    bg={colors.background.light}
                    textColor={colors.text.secondary}
                  />
                )}
                <Row
                  label="CA net (apres quote-part)"
                  data={caNet}
                  formatValue={formatMontant}
                  bg={`${colors.primary.teal}20`}
                  textColor={colors.primary.teal}
                  bold
                />
                <Row
                  label="Montant facturé"
                  data={factures}
                  bg={`${colors.primary.gold}40`}
                  formatValue={formatMontant}
                />
                <Row
                  label="Reste a facturer"
                  data={reste}
                  formatValue={formatMontant}
                  bold
                  resteMode
                />
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

export default PLRefacturationTable;
